<template>
  <div v-click-outside="outClose">
    <div :class="idx > 4 ? 'dropup' : 'dropdown'">
      <button
        class="btn dropdown-toggle drp-dwn-btn"
        type="button"
        data-toggle="dropdown"
      >
        {{ estimatedTime }} <span class="caret"></span>
      </button>
      <ul class="dropdown-menu drop-menu-est-time">
        <li v-for="(item, idx) in estTimes" :key="idx">
          <a href="#" @click.prevent="changeEstTime($event, idx)">{{
            item.title
          }}</a>
        </li>
      </ul>
    </div>
    <!--    <div class="selector-btn" @click="showEditTime = true" v-if="!showEditTime">-->
    <!--      {{ taskTimeQuantity ? taskTimeQuantity : "0" }}-->
    <!--    </div>-->
    <!--    <div>-->
    <!--      <span class="date-picker" v-if="showEditTime">-->
    <!--        <input-->
    <!--          class="input-timer"-->
    <!--          min="0"-->
    <!--          type="number"-->
    <!--          v-model="taskTimeQuantity"-->
    <!--        />-->
    <!--        &lt;!&ndash; <a-->
    <!--          class="new-client-ok-btn"-->
    <!--          href="javascript:void(0)"-->
    <!--          @click.prevent="updateTimeQuantity"-->
    <!--          ><span class="fa fa-check"></span-->
    <!--        ></a>&ndash;&gt;-->
    <!--      </span>-->
    <!--    </div>-->
  </div>
</template>

<script>
import moment from "moment";
import vClickOutside from "v-click-outside";
import apiClientCreator from "../../../helpers/api/request";

export default {
  name: "TaskTimeQuantity",
  components: {},
  props: {
    task: {
      type: Object,
      required: true
    },
    idx: {
      type: Number
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      estimatedTime: "0 hours",
      taskTimeQuantity:
        this.task.time_quantity === null ? 0 : this.task.time_quantity,
      showEditTime: false,
      estTimes: [
        { title: "COMP. EVENT" },
        { title: "OUTLINE" },
        { title: "15 minutes" },
        { title: "30 minutes" },
        { title: "1 hour" },
        { title: "2 hours" },
        { title: "3 hours" },
        { title: "6 hours" },
        { title: "9 hours" },
        { title: "12 hours" },
        { title: "15 hours" },
        { title: "1 day" },
        { title: "2 days" },
        { title: "3 days" },
        { title: "week" },
        { title: "2 weeks" },
        { title: "month" },
        { title: "2 month" },
        { title: "3 month" },
        { title: "Half a year" },
        { title: "9 month" },
        { title: "Year" },
        { title: "Year and half" },
        { title: "2 years" },
        { title: "3 years" },
        { title: "5 years" }
      ]
    };
  },

  methods: {
    getEstTimeTitle(estimatedTime) {
      switch (estimatedTime) {
        case 0:
          this.estimatedTime = "OUTLINE";

          // this.$emit("reapetOption", this.selectedRepeatOption);
          // this.$emit("outLineTaskDateTime");
          break;
        case 0.25:
          this.estimatedTime = "15 minutes";
          break;
        case 0.5:
          this.estimatedTime = "30 minutes";
          break;
        case 1:
          this.estimatedTime = "1 hour";
          break;
        case 2:
          this.estimatedTime = "2 hours";
          break;
        case 3:
          this.estimatedTime = "3 hours";
          break;
        case 6:
          this.estimatedTime = "6 hours";
          break;
        case 9:
          this.estimatedTime = "9 hours";
          break;
        case 12:
          this.estimatedTime = "12 hours";
          break;
        case 15:
          this.estimatedTime = "15 hours";
          break;
        case 24:
          this.estimatedTime = "1 day";
          break;
        case 48:
          this.estimatedTime = "2 days";
          break;
        case 72:
          this.estimatedTime = "3 days";
          break;
        case 168:
          this.estimatedTime = "week";
          break;
        case 336:
          this.estimatedTime = "2 weeks";
          break;
        case 720:
          this.estimatedTime = "month";
          break;
        case 1440:
          this.estimatedTime = "2 month";
          break;
        case 2160:
          this.estimatedTime = "3 month";
          break;
        case 4320:
          this.estimatedTime = "Half a year";
          break;
        case 6480:
          this.estimatedTime = "9 month";
          break;
        case 8640:
          this.estimatedTime = "Year";
          break;
        case 12960:
          this.estimatedTime = "Year and half";
          break;
        case 17280:
          this.estimatedTime = "2 years";
          break;
        case 25920:
          this.estimatedTime = "3 years";
          break;
        case 43200:
          this.estimatedTime = "5 years";
          break;
        default:
          this.estimatedTime = "OUTLINE";
      }
    },
    changeEstTime(event, rangeId) {
      this.estimatedTime = event.target.innerText;
      this.changeEndTaskTime();
    },
    changeEndTaskTime() {
      switch (this.estimatedTime) {
        case "OUTLINE":
          this.taskTimeQuantity = 0;

          // this.$emit("reapetOption", this.selectedRepeatOption);
          // this.$emit("outLineTaskDateTime");
          break;
        case "15 minutes":
          this.taskTimeQuantity = 0.25;
          break;
        case "30 minutes":
          this.taskTimeQuantity = 0.5;
          break;
        case "1 hour":
          this.taskTimeQuantity = 1;
          break;
        case "2 hours":
          this.taskTimeQuantity = 2;
          break;
        case "3 hours":
          this.taskTimeQuantity = 3;
          break;
        case "6 hours":
          this.taskTimeQuantity = 6;
          break;
        case "9 hours":
          this.taskTimeQuantity = 9;
          break;
        case "12 hours":
          this.taskTimeQuantity = 12;
          break;
        case "15 hours":
          this.taskTimeQuantity = 15;
          break;
        case "1 day":
          this.taskTimeQuantity = 24;
          break;
        case "2 days":
          this.taskTimeQuantity = 48;
          break;
        case "3 days":
          this.taskTimeQuantity = 72;
          break;
        case "week":
          this.taskTimeQuantity = 168;
          break;
        case "2 weeks":
          this.taskTimeQuantity = 336;
          break;
        case "month":
          this.taskTimeQuantity = 720;
          break;
        case "2 month":
          this.taskTimeQuantity = 1440;
          break;
        case "3 month":
          this.taskTimeQuantity = 2160;
          break;
        case "Half a year":
          this.taskTimeQuantity = 4320;
          break;
        case "9 month":
          this.taskTimeQuantity = 6480;
          break;
        case "Year":
          this.taskTimeQuantity = 8640;
          break;
        case "Year and half":
          this.taskTimeQuantity = 12960;
          break;
        case "2 years":
          this.taskTimeQuantity = 17280;
          break;
        case "3 years":
          this.taskTimeQuantity = 25920;
          break;
        case "5 years":
          this.taskTimeQuantity = 43200;
          break;
        default:
      }
    },

    outClose() {
      if (this.showEditTime) {
        if (this.task.time_quantity !== this.taskTimeQuantity) {
          this.updateTimeQuantity();
        } else {
          this.showEditTime = false;
        }
      }
    },

    async updateTimeQuantity() {
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(
          `tasks/update/time_quantity/${this.task.id}`
        );
        await addNewClientRequest.put("", {
          time_quantity: this.taskTimeQuantity
        });
        //  this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        this.showEditTime = false;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task priority quantity successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task time quantity update " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    }
  },
  watch: {
    taskTimeQuantity: function() {
      if (this.task.time_quantity !== this.taskTimeQuantity) {
        this.updateTimeQuantity();
      }
    }
  },
  mounted() {
    if (this.task) {
      this.getEstTimeTitle(this.task.time_quantity);
    }
  }
};
</script>

<style scoped>
.selector-btn {
  border: none;
  background: none;
  border-radius: 3px;
  cursor: pointer;
}
.selector-btn:hover {
  background: #9e9e9e;
}
.input-timer {
  width: 100%;
  padding: 2px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 23px;
  border-width: thin;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}
.new-client-ok-btn {
  color: green !important;
}
.drp-dwn-btn {
  background-color: transparent;
}
.task-item-td-time-quantity-short .drp-dwn-btn {
  background-color: transparent;
  font-size: 10px;
}
.drop-menu-est-time {
  min-width: 122px;
  max-height: 330px;
  overflow-y: scroll;
}
</style>
